var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.178,
    height: 16.178,
    viewBox: "0 0 16.178 16.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3351",
    "data-name": "Group 3351",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3215",
    "data-name": "Path 3215",
    d: "M822.137,2287.125V2284.5a.548.548,0,0,1,.348-.348h2.592c.144.059.281.129.319.3a1.152,1.152,0,0,1,.02.234c0,.244,0,.49,0,.731h9.626c0-.24.013-.467,0-.691a.51.51,0,0,1,.311-.572h2.624a.5.5,0,0,1,.341.567c-.01.748,0,1.5,0,2.244a.412.412,0,0,1-.463.468h-.791v9.627h.77c.344,0,.485.143.485.492v2.275c0,.352-.149.5-.5.5h-2.275c-.354,0-.5-.144-.5-.5v-.76h-9.626v.762c0,.354-.142.5-.5.5-.737,0-1.475-.007-2.212,0a.508.508,0,0,1-.569-.341V2297.4a.484.484,0,0,1,.563-.343c.234.015.469,0,.7,0v-9.627c-.24,0-.468-.013-.691,0A.511.511,0,0,1,822.137,2287.125Zm8.076,11.165q2.33,0,4.661,0c.129,0,.178-.032.171-.167-.011-.194,0-.39,0-.584,0-.341.139-.482.474-.482h.538c.22,0,.22,0,.22-.222v-9.181a.621.621,0,0,1,0-.079c.013-.107-.027-.151-.141-.146-.216.008-.432,0-.648,0a.4.4,0,0,1-.444-.45c0-.189,0-.379,0-.569,0-.212,0-.212-.215-.212h-7.316c-.648,0-1.3,0-1.944,0-.116,0-.16.03-.154.15.008.2,0,.4,0,.6,0,.34-.14.482-.475.482H824.4c-.219,0-.22,0-.22.223v9.181a.622.622,0,0,1,0,.079c-.013.107.027.15.141.146.216-.008.432,0,.647,0a.4.4,0,0,1,.444.45c0,.195.012.391,0,.584-.013.164.044.2.2.2C827.147,2298.287,828.68,2298.29,830.213,2298.29Zm-7.285-11.639h1.7v-1.706h-1.7Zm14.6,0v-1.705h-1.7v1.705Zm-12.894,12.895v-1.705h-1.706v1.705Zm12.894,0v-1.706h-1.7v1.706Z",
    transform: "translate(-822.137 -2284.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3216",
    "data-name": "Path 3216",
    d: "M822.137,2284.571",
    transform: "translate(-822.137 -2284.223)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.c988eea01398b943189dcec630ba55fa.svg";
export { ForwardRef as ReactComponent };